import React from 'react';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ErrorBoundary from './components/ErrorBoundary';
import MFAWrapper from './components/MFAWrapper';

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <MFAWrapper>
            <Routes />
          </MFAWrapper>
        </AuthProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;